import { css } from 'emotion';

export const jubcss = (styles: any) => {
  return css`
    .jubjub & {
      ${styles}
    }
  `;
};
